// src/extensions/MuiAlertView.jsx
import React from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import Alert from '@mui/material/Alert'

export default function MuiAlertView({ node }) {
  const severity = node.attrs.severity || 'info'

  return (
    <NodeViewWrapper as="div" data-mui-alert="">
      <Alert severity={severity}>
        {node.content?.content?.[0]?.text || 'Alert content'}
      </Alert>
    </NodeViewWrapper>
  )
}
